import EventBus from "@plugins/common/service/eventbus";

const myDriveEventBus = new EventBus();

export default myDriveEventBus;
